/**
 * @deprecated This constant will be removed with v6.0.0, please use PANCAKE_LIGHT instead
 */
export var LOLLIPOP_LIGHT = '4.0.0-light';

/**
 * @deprecated This constant will be removed with v6.0.0, please use PANCAKE_LIGHT instead
 */
export var LOLLIPOP_DARK = '4.0.0-dark';
export var PANCAKE_LIGHT = '5.0.0-light';
export var PANCAKE_DARK = '5.0.0-dark';
/**
 * @deprecated This function will be removed with v6.0.0
 */
export var isLollipop = designVersion => designVersion === LOLLIPOP_LIGHT || designVersion === LOLLIPOP_DARK;
export var isPancake = designVersion => designVersion === PANCAKE_LIGHT || designVersion === PANCAKE_DARK;
export var isDarkMode = designVersion => designVersion === LOLLIPOP_DARK || designVersion === PANCAKE_DARK;
//# sourceMappingURL=index.js.map